import { render } from "./OlapSaveNewVersionDialog.vue?vue&type=template&id=108c1010&ts=true"
import script from "./OlapSaveNewVersionDialog.vue?vue&type=script&lang=ts"
export * from "./OlapSaveNewVersionDialog.vue?vue&type=script&lang=ts"

import "./OlapSaveNewVersionDialog.vue?vue&type=style&index=0&id=108c1010&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__